module.exports = __webpack_public_path__ + "static/rcc-os-chart-desktop-0e284b962f6803dd2e6ac71b9978023a.png";